
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useIsMobile } from "@/hooks/use-mobile";
import NavbarBrand from "./NavbarBrand";
import NavLinks from "./NavLinks";
import UserMenu from "./UserMenu";
import MobileMenu from "./MobileMenu";

interface NavbarProps {
  toggleSidebar: () => void;
}

const Navbar = ({ toggleSidebar }: NavbarProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, profile, signOut, hasRole } = useAuth();
  const isMobile = useIsMobile();

  const getInitials = (email: string) => {
    return email.substring(0, 2).toUpperCase();
  };

  const canViewDocs = hasRole(["admin", "analyst"]);
  const isAdmin = profile?.role === "admin";

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-white dark:bg-fraudeye-primary dark:border-fraudeye-secondary">
      <div className="container flex h-16 items-center justify-between py-4">
        <div className="flex items-center gap-2">
          {isMobile && (
            <Button 
              variant="ghost" 
              size="icon" 
              className="md:hidden mr-2"
              onClick={toggleSidebar}
            >
              <Menu className="h-5 w-5" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          )}
          
          <NavbarBrand />
        </div>
        
        <div className="hidden md:flex items-center gap-6">
          <NavLinks canViewDocs={canViewDocs} isAdmin={isAdmin} />
          <UserMenu user={user} signOut={signOut} getInitials={getInitials} />
        </div>
        
        <Button
          variant="ghost"
          size="icon"
          className="block md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </Button>
      </div>
      
      <MobileMenu 
        isOpen={isMenuOpen}
        user={user}
        canViewDocs={canViewDocs}
        isAdmin={isAdmin}
        signOut={signOut}
        onClose={() => setIsMenuOpen(false)}
      />
    </header>
  );
};

export default Navbar;
